import type { SchedulingAvailabilityInfo } from '@carvana/merch-contracts';
import type { MegaEventVehicleAvailability } from '~/contracts/common/MegaEventVehicle';

export default function getMegaEventVehicleAvailability(
  availability?: SchedulingAvailabilityInfo
): MegaEventVehicleAvailability | undefined {
  if (!availability) return undefined;

  return {
    daysToAvailability: availability.daysToAvailability,
    drivingMiles: availability.drivingMiles,
    isRestrictedLocation: availability.isRestrictedLocation,
    locationCity: availability.locationCity,
    locationState: availability.locationState,
    servicingLocationId: availability.servicingLocationId
  };
}
